<template>
  <div class="right-content">
    <div class="box" @click="handleClick(1)">
      <div class="flex-space-between top-title">
        <h4 style="font-weight: 400;">医生信息</h4>
        <div class="topRighgt-btn">详情</div>
      </div>
      <div class="flex-start userInfo">
        <img class="userIcon" :src="`${CommonPath}${detailInfo.photoFile}`" v-if="detailInfo.photoFile" />
        <img class="userIcon" v-else src="https://oss.qyyl365.com/PC/touxiang.png" />
        <div>
          <div class="flex-start">
            <div class="doctor-1">{{ detailInfo.doctorName }} {{ detailInfo.departmentName }}</div>
            <img style="margin-right: 5px" src="@/assets/img/rz_label.png" />
          </div>
          <div class="top-bottom">证书编号：{{ detailInfo.certificateNumber }}</div>
        </div>
      </div>
      <div class="desc twoLine" v-if="detailInfo.profile">简介:{{ detailInfo.profile }}</div>
    </div>
    <div class="box" @click="handleClick(2)">
      <div class="flex-space-between top-title">
        <h4 style="font-weight: 400;">病历卡</h4>
        <div class="topRighgt-btn">详情</div>
      </div>
      <div class="userInfo">
        <div class="doctor-1">
          {{ detailInfo.patientName }} {{ detailInfo.sex ? "男" : "女" }} {{ getAge(detailInfo?.birthday) }}岁（{{ detailInfo.birthday?.split("T")[0] }}）
          <template v-if="detailInfo.relationshipToPatient == 0">本人</template>
          <template v-if="detailInfo.relationshipToPatient == 1">子女</template>
          <template v-if="detailInfo.relationshipToPatient == 2">父母</template>
          <template v-if="detailInfo.relationshipToPatient == 3">其他</template>
        </div>
        <div class="desc flex-start" style="text-align: left; margin: 5px 0; align-items: start">
          <div class="left-title">就诊疾病：</div>
          <div class="right-val twoLine">{{ detailInfo.diseaseDiagnose }}</div>
        </div>
        <div class="desc flex-start" style="text-align: left; align-items: start">
          <div class="left-title">病情描述：</div>
          <div class="right-val twoLine">{{ detailInfo?.description }}</div>
        </div>
      </div>
    </div>
    <div class="flex-center">
      <div class="btn1" @click.stop="$emit('stopConsultation')">终止问诊</div>
      <div class="btn2" @click.stop="$emit('complateConsultation')">完成问诊</div>
    </div>
    <el-drawer class="drawer" :append-to-body="true" :title="clickBtn == 1 ? '医生信息' : '病例详情'" :visible.sync="drawer" :with-header="true">
      <template v-if="clickBtn == 1">
        <div class="box2">
          <div class="flex-start userInfo">
            <img class="userIcon" :src="`${CommonPath}${detailInfo.photoFile}`" v-if="detailInfo.photoFile" />
            <img class="userIcon" v-else src="@/assets/img/touxiang03.png" />
            <div>
              <div class="flex-start">
                <div class="doctor-1">{{ detailInfo.doctorName }} {{ detailInfo.departmentName }}</div>
                <img style="margin-right: 5px" src="@/assets/img/rz_label.png" v-if="detailInfo.certificateNumber" />
              </div>
              <div class="top-bottom">证书编号：{{ detailInfo.certificateNumber }}</div>
            </div>
          </div>
          <div class="desc" style="margin: 10px 0" v-if="detailInfo.expertise">擅长:{{ detailInfo.expertise }}</div>
          <div class="desc" v-if="detailInfo.profile">简介:{{ detailInfo.profile }}</div>
        </div>
      </template>
      <template v-if="clickBtn == 2">
        <div class="box2">
          <div class="userInfo">
            <div class="doctor-1">
              {{ detailInfo.patientName }} {{ detailInfo.sex ? "男" : "女" }} {{ getAge(detailInfo?.birthday) }}岁（{{ detailInfo.birthday?.split("T")[0] }}）
              <template v-if="detailInfo.relationshipToPatient == 0">本人</template>
              <template v-if="detailInfo.relationshipToPatient == 1">子女</template>
              <template v-if="detailInfo.relationshipToPatient == 2">父母</template>
              <template v-if="detailInfo.relationshipToPatient == 3">其他</template>
            </div>
            <div class="desc" style="text-align: left; margin-bottom: 20px; margin-top: 10px; align-items: start">
              <h4 style="color: #aa2f2f; width: 100%">就诊疾病</h4>
              <div class="right-val">{{ detailInfo.diseaseDiagnose }}</div>
            </div>
            <div v-if="detailInfo.diseaseImage.length>0">
              <span style="font-weight: bold">检查报告/患者处方照片</span>
              <div class=" flex-start flex-warp">
                <div v-for="(files,i) in detailInfo.diseaseImage" :key="i">
                  <el-image fit="cover" style="width: 100px;height: 100px;margin-right: 5px;margin-bottom: 5px;" hide-on-click-modal :src="Services.ossUpload + files.filePath" preview-teleported :zoom-rate="1.2" :preview-src-list="[Services.ossUpload + files.filePath]"></el-image>
                </div>
               
              </div>
            </div>
            <div class="desc" style="text-align: left; align-items: start; margin-bottom: 20px">
              <h4 style="color: #aa2f2f">详细病情</h4>
              <div style="margin-bottom: 8px">
                <div class="left-title" style="margin: 5px 0; width: 100%">病情描述</div>
                <div class="right-val">{{ detailInfo?.description }}</div>
              </div>
              <div style="margin-bottom: 8px">
                <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">患病时长</div>
                <div class="right-val">{{ detailInfo?.patientAnswerRecordDetailList[1]?.userAnswer[0]?.quesAnsName }}</div>
              </div>
              <div style="margin-bottom: 8px" v-if="detailInfo?.patientAnswerRecordDetailList[3]?.userAnswer[0]?.quesAnsName == '有'">
                <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">当前正在使用的药物</div>
                <div class="right-val">{{ detailInfo?.patientAnswerRecordDetailList[3]?.userAnswer[0]?.otherData[0]?.patientHisDrug }}</div>
              </div>
            </div>
            <div class="desc" style="text-align: left; align-items: start; margin-bottom: 20px" v-if="detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.quesAnsName == '有' || detailInfo?.patientAnswerRecordDetailList[5]?.userAnswer[0]?.quesAnsName == '有'">
              <h4 style="color: #aa2f2f">既往史</h4>
              <template v-if="detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.quesAnsName == '有'">
                <div style="margin-bottom: 8px" v-for="(item, index) in detailInfo?.patientAnswerRecordDetailList[4]?.userAnswer[0]?.otherData" :key="index">
                  <div class="left-title" style="margin: 5px 0; width: 100%">{{ item.name }}</div>
                  <div class="right-val">{{ item.des }}</div>
                </div>
              </template>

              <div style="margin-bottom: 8px" v-if="detailInfo?.patientAnswerRecordDetailList[5]?.userAnswer[0]?.quesAnsName == '有'">
                <div class="left-title" style="margin: 10px 0 5px 0; width: 100%">慢性病史</div>
                <div class="right-val">{{ detailInfo?.patientAnswerRecordDetailList[5]?.userAnswer[0]?.otherData[0]?.diseasesDes }}</div>
              </div>
            </div>
            <div class="desc" style="text-align: left; margin-bottom: 20px; align-items: start">
              <h4 style="color: #aa2f2f; width: 100%">体格检查</h4>
              <div class="right-val">{{ detailInfo?.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patientHeight }}cm,{{ detailInfo.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patientWeight }}kg({{ detailInfo?.patientAnswerRecordDetailList[0]?.userAnswer[0]?.otherData[0]?.patienTtestTime }}测量)</div>
            </div>
          </div>
        </div>
      </template>
    </el-drawer>
  </div>
</template>

<script>
import { DoctorAppointment } from "@/components/Drug/DoctorAppointment";
export default {
  data() {
    var doctorAppointment = new DoctorAppointment(this.TokenClient, this.Services.Drug);
    return {
      DoctorAppointment: doctorAppointment,
      drawer: false,
      clickBtn: 1,
      detailInfo: {},
    };
  },
  mounted() {},
  methods: {
    getAge(date) {
      const birthDate = new Date(date);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    },
    getDetail(orderId, isFirst) {
      var _this = this;
      return new Promise((resolve, reject) => {
        _this.DoctorAppointment.OrderInfo(
        orderId,
        function (data) {
          _this.detailInfo = data.data;
                if(_this.detailInfo.diseaseImage){
            _this.detailInfo.diseaseImage=JSON.parse(_this.detailInfo.diseaseImage)
          }
          _this.detailInfo?.patientAnswerRecordDetailList.map((res) => {
            res.userAnswer = JSON.parse(res.userAnswer);
          });
          if (isFirst == 0) {
            _this.$emit("sedFirstMsg", { data: _this.detailInfo });
          }
          resolve(data.data) 
        },
        function (err) {}
      );
      })
    },
    handleClick(num) {
      this.drawer = true;
      this.clickBtn = num;
    },
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return `${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;
    },
    formatDate(dateString) {
      const today = new Date().toDateString();
      const yesterday = new Date(Date.now() - 86400000).toDateString();
      const date = new Date(dateString);

      if (dateString === today) return "今天";
      if (dateString === yesterday) return "昨天";

      return `${date.getMonth() + 1}月${date.getDate()}日`;
    },
  },
};
</script>
<style scoped lang="scss">
.right-content {
  height: 100%;
  overflow-y: auto;
}
.right-content .bscroll-vertical-scrollbar {
  display: none !important;
}
.box {
  padding: 5px 10px;
  background: #f5f7fa;
  border-radius: 6px;
  width: 85%;
  margin: 20px auto;
  cursor: pointer;
}
.box2 {
  border-radius: 6px;
  width: 90%;
  margin: 20px auto;
}
.top-title {
  margin-bottom: 5px;
}
.topRighgt-btn {
  color: #00afb5;
  cursor: pointer;
  font-size: 12px;
}
.userInfo {
  margin: 5px 0;
}
.userIcon {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-right:5px
}
.doctor-1 {
  font-weight: bold;
  margin-right: 5px;
  text-align: left;
}
.top-bottom {
  color: #666666;
  font-size: 12px;
  text-align: left;
}
.desc {
  line-height: 1.4;
  font-size: 12px;
  text-align: left;
}
.left-title {
  color: #999999;
  width: 60px;
}
.right-val {
  width: calc(100% - 60px);
}
.btn1 {
  background: #eb8c4c;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  padding: 4px 10px;
  margin-right: 10px;
  cursor: pointer;
  line-height: 21px;
}
.btn2 {
  background: #5f80ea;
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  padding: 4px 10px;
  margin-right: 10px;
  cursor: pointer;
  line-height: 21px;
}
.btn3 {
  background: var(--base--bg);
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  padding: 4px 10px;
  margin-right: 5px;
  cursor: pointer;
  line-height: 21px;
}
.drawer {
  font-size: 17px;
  .userIcon {
    width: 55px;
    height: 55px;
  }
  .top-bottom,
  .desc .right-val {
    font-size: 14px;
  }
}
</style>
